// You can write more code here

/* START OF COMPILED CODE */

import TilemapScene from "./TilemapScene";
import Player from "../../prefabs/World/Player";
import WorldNode from "../../prefabs/World/WorldNode";
import Portal from "../../prefabs/World/Portal";
import Mentor4 from "../../prefabs/World/Mentors/Mentor4";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level19 extends TilemapScene {

	constructor() {
		super("Level19");

		/* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
	}

	editorCreate(): void {

		// winter_biome_4
		const winter_biome_4 = this.add.tilemap("winter-biome-4");
		winter_biome_4.addTilesetImage("winter forest wang tiles (snowy)", "winter forest wang tiles (snowy)");
		winter_biome_4.addTilesetImage("winter forest (snowy)", "winter forest (snowy)");
		winter_biome_4.addTilesetImage("winter (snowy) 32x32", "winter (snowy) 32x32");
		winter_biome_4.addTilesetImage("winter (snowy) 16x32", "winter (snowy) 16x32");
		winter_biome_4.addTilesetImage("winter (clean) 32x32", "winter (clean) 32x32");
		winter_biome_4.addTilesetImage("winter (clean) 48x32", "winter (clean) 48x32");
		winter_biome_4.addTilesetImage("winter trees (snowy) 80x112", "winter trees (snowy) 80x112");
		winter_biome_4.addTilesetImage("collision", "collision & alpha");

		// terrain_1
		winter_biome_4.createLayer("terrain", ["winter forest wang tiles (snowy)"], 0, 0);

		// cliffside_1
		winter_biome_4.createLayer("cliffside", ["winter forest (snowy)"], 0, 0);

		// shelves_1
		winter_biome_4.createLayer("shelves", ["winter forest (snowy)"], 0, 0);

		// deco
		winter_biome_4.createLayer("deco 1", ["winter (snowy) 16x32","winter (snowy) 32x32","winter forest (snowy)","winter (clean) 32x32","winter (clean) 48x32"], 0, 0);

		// cOLLISION_1
		const cOLLISION_1 = winter_biome_4.createLayer("COLLISION", ["collision"], 0, 0)!;
		cOLLISION_1.visible = false;

		// player
		const player = new Player(this, 216, 32);
		this.add.existing(player);

		// worldNode
		const worldNode = new WorldNode(this, 344, 80);
		this.add.existing(worldNode);

		// worldNode_1
		const worldNode_1 = new WorldNode(this, 664, 96);
		this.add.existing(worldNode_1);

		// worldNode_2
		const worldNode_2 = new WorldNode(this, 456, 232);
		this.add.existing(worldNode_2);

		// worldNode_3
		const worldNode_3 = new WorldNode(this, 560, 392);
		this.add.existing(worldNode_3);

		// worldNode_4
		const worldNode_4 = new WorldNode(this, 656, 560);
		this.add.existing(worldNode_4);

		// worldNode_5
		const worldNode_5 = new WorldNode(this, 104, 584);
		this.add.existing(worldNode_5);

		// portal
		const portal = new Portal(this, 48, 616);
		this.add.existing(portal);

		// mentor
		const mentor = new Mentor4(this, 168, 64);
		this.add.existing(mentor);

		// worldNode_6
		const worldNode_6 = new WorldNode(this, 360, 552);
		this.add.existing(worldNode_6);

		// worldNode_7
		const worldNode_7 = new WorldNode(this, 528, 552);
		this.add.existing(worldNode_7);

		// worldNode_8
		const worldNode_8 = new WorldNode(this, 592, 200);
		this.add.existing(worldNode_8);

		// worldNode_9
		const worldNode_9 = new WorldNode(this, 536, 112);
		this.add.existing(worldNode_9);

		// worldNode (prefab fields)
		worldNode.NPCLevelId = 18;
		worldNode.NPCId = 0;

		// worldNode_1 (prefab fields)
		worldNode_1.NPCLevelId = 18;
		worldNode_1.NPCId = 1;

		// worldNode_2 (prefab fields)
		worldNode_2.NPCLevelId = 18;
		worldNode_2.NPCId = 2;

		// worldNode_3 (prefab fields)
		worldNode_3.NPCLevelId = 18;
		worldNode_3.NPCId = 3;

		// worldNode_4 (prefab fields)
		worldNode_4.NPCLevelId = 18;
		worldNode_4.NPCId = 4;

		// worldNode_5 (prefab fields)
		worldNode_5.NPCLevelId = 18;
		worldNode_5.NPCId = 5;

		// worldNode_6 (prefab fields)
		worldNode_6.NPCLevelId = 18;
		worldNode_6.NPCId = 5;

		// worldNode_7 (prefab fields)
		worldNode_7.NPCLevelId = 18;
		worldNode_7.NPCId = 5;

		// worldNode_8 (prefab fields)
		worldNode_8.NPCLevelId = 18;
		worldNode_8.NPCId = 5;

		// worldNode_9 (prefab fields)
		worldNode_9.NPCLevelId = 18;
		worldNode_9.NPCId = 5;

		this.player = player;
		this.portal = portal;
		this.mentor = mentor;
		this.winter_biome_4 = winter_biome_4;

		this.events.emit("scene-awake");
	}

	private player!: Player;
	private portal!: Portal;
	private mentor!: Mentor4;
	private winter_biome_4!: Phaser.Tilemaps.Tilemap;

	/* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.winter_biome_4,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
